<!--  -->
<template>
  <div class="dialog">
    <el-dialog :visible.sync="dialogVisible" :before-close="close" :close-on-press-escape="closeModal" :close-on-click-modal="closeModal" :show-close="showClose" width="100%">
      <div id="dialog-content">
        <component :is="component" :params="params" :ref='refName' :contiune="contiune" :refresh="refresh" @closeFun="close"></component>
      </div>
      <!-- <span>这是一段信息</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>

  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue'
export default {
  // props: ['dialogVisible', 'showClose', 'params', 'component', 'refresh', 'closeModal', 'contiune'],
  props: {
    'dialogVisible': { type: Boolean, required: true },
    'showClose': { type: Boolean, default: true },
    'params': { type: Object, required: true },
    'component': {},
    'closeModal': { type: Boolean, default: false },
    'contiune': { type: Boolean, default: false },
    'refresh': {},
    'refName': { type: String, default: '' }
  },
  data () {
    return {}
  },
  methods: {
    close () {
      if (typeof this.refresh !== 'undefined' && this.refresh instanceof Function) {
        this.refresh()
      }
      if (this.refName && this.refName !== '') {
        this.$refs[this.refName].resetForm()
      }
      this.$emit('update:dialogVisible', false)
      this.$emit('closeChange')
    }
  },
  watch: {}
}

</script>
<style lang='scss'>
  .dialog {
    .el-dialog {
      max-width: 500px;
      max-height: 640px;
    }

    .el-dialog__body {
      padding: 20px 70px 56px;
    }
    @media (max-width: 768px) {
      .el-dialog__body {
        padding: 30px 20px;
      }
    }
  }

</style>
